import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputMultiChoiceAtLeatOneErrorMessage = (
  <Trans>
    Vous devez au moins sélectionner une option dans ce champ
  </Trans>
);
